import React, { useState } from 'react';

function Login() {
  window.scrollTo(0, 0);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    // Continue with your login logic
    setFormData({
      email: "",
      password: "",
    });
  };

  const { email, password } = formData;

  return (
    <div className="container mt-1 mb-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <h1 className="text-center mb-4"><b>Login</b></h1>
          <form onSubmit={onSubmit} className="signup-form">
            <div className="mb-3">
              <label htmlFor="email" className="form-label"><b>Email:</b></label>
              <input type="email" className="form-control" id="email" name="email" value={email} onChange={onChange} required />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label"><b>Password:</b></label>
              <input type="password" className="form-control" id="password" name="password" value={password} onChange={onChange} required />
            </div>
            <div className="text-center">
              <button type="submit" className="btn btn-danger mb-5"><b>Submit</b></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
